import React, { Component } from 'react';

import InputBox from '../../../../etc/InputBox';
import SelectBox from '../../../../etc/SelectBox';

class UpdateItem extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
  }

  onChange = (e) => {
    console.log(e);
  };
  
  render() {
    return (
      <>
        <div className="card col-md-12">
          <div className="card-header">
            수정 요청
          </div>
          <div className="card-body">
            <div className="row mb-2">
              <div className="col-md-6">
                <InputBox
                  title="요청자"
                  value={[{ value : "나철수 [110112]" }]}
                />
              </div>
              <div className="col-md-6">
                <InputBox
                  title="요청일자"
                  value={[{ value : "2021-05-05" }]}
                />
              </div>
            </div>
            <div className="row mb-2">
              <div className="col-md-6">
                <InputBox
                  title="관리번호"
                  value={[{ value : "87921" }]}
                />
              </div>
              <div className="col-md-6 form-group">
                <label htmlFor=""><strong>요청구분</strong></label>
                <SelectBox 
                  OptionData={[
                    { "value" : 1, "name": "본인성과아님" },
                    { "value" : 2, "name": "저자수정" },
                    { "value" : 3, "name": "논문특정정보수정" },
                    { "value" : 4, "name": "기타수정" },
                  ]}
                />
              </div>
            </div>
            <div className="row mb-2">
              <div className="col-md-12 form-group">
                <label htmlFor="journal_title"><strong>요청내용</strong></label>
                <textarea className="form-control" placeholder="" id=""></textarea>
              </div>
            </div>
          </div>
        </div>

        <div className="card col-md-12">
          <div className="card-header">
            처리결과
          </div>
          <div className="card-body">
            <div className="row mb-2">
              <div className="col-md-6">
                <InputBox
                  title="처리자"
                  value={[{ value : "박경석 [490160]" }]}
                />
              </div>
              <div className="col-md-6">
                <InputBox
                  title="처리일자"
                  value={[{ value : "2021-05-05" }]}
                />
              </div>
            </div>
            <div className="row mb-2">
              <div className="col-md-6">
                <InputBox
                  title="관리번호"
                  value={[{ value : "87921" }]}
                />
              </div>
              <div className="col-md-6 form-group">
                <label htmlFor=""><strong>상태</strong></label>
                <SelectBox 
                  OptionData={[
                    { "value" : 1, "name": "미처리" },
                    { "value" : 2, "name": "처리중" },
                    { "value" : 3, "name": "처리완료" },
                  ]}
                />
              </div>
            </div>
            <div className="row mb-2">
              <div className="col-md-12 form-group">
                <label htmlFor="journal_title"><strong>처리내용</strong></label>
                <textarea className="form-control" placeholder="" id=""></textarea>
              </div>
            </div>
          </div>
        </div>
      </>
    )
  }
}

export default UpdateItem;